import React from 'react';

const BlogItem = () => {
    return (
        <div>
            <h1 className="display-1 text-dark text-center">Coming soon...</h1>
        </div>
    );
};
<h1>Coming soon...</h1>
export default BlogItem;